import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components';
import { Color, Colors } from '../styles/Colors';
import Arrow from './icons/Arrow';

const ScrollBtn = styled.button`
    position: fixed; 
    right: 40%; 
    bottom: 1rem; 
    transform: translateX(-40%);
    bottom: 2rem;  
    background-color: ${Color(Colors.black)}; 
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.3);
    border: none; 
    border-radius: 50%; 
    width: 38px; 
    height: 38px;  
    cursor: pointer;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
    pointer-events: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

    & > svg {
        transform: rotate(${({ $atBottom }) => ($atBottom ? '-90deg' : '90deg')});
        transition: transform 0.3s ease; 
        width: 22px;
        height: 100%; 
    }

    @media (max-width: 1150px) {
        width: 42px; 
        height: 42px;  

        & > svg {
            width: 24px; 
        }
    }
`;

const ScrollButton = ({bottomRef}) => {
    const [atBottom, setAtBottom] = useState(false);
    const [isAutoScrolling, setIsAutoScrolling] = useState(false);
    const [showScrollButton, setShowScrollButton] = useState(false);

    const scrollEndTimeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPos = window.innerHeight + window.scrollY;
            const pageHeight = document.body.offsetHeight;
            const nearBottomThreshold = 100;
            const nearTopThreshold = 100;

            const nearBottom = scrollPos >= pageHeight - nearBottomThreshold
            const nearTop = window.scrollY <= nearTopThreshold

            if (nearBottom) {
                setAtBottom(true)
            } else if (nearTop) {
                setAtBottom(false)
            }

            setShowScrollButton(!nearTop && !nearBottom);

            if (scrollEndTimeoutRef.current) {
                clearTimeout(scrollEndTimeoutRef.current);
            }

            scrollEndTimeoutRef.current = setTimeout(() => {
                setIsAutoScrolling(false);
            }, 120);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (scrollEndTimeoutRef.current) {
                clearTimeout(scrollEndTimeoutRef.current);
            }
        };
    }, []);

    const scrollToBottom = () => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleScrollClick = () => {
        if (isAutoScrolling) return;

        setIsAutoScrolling(true);

        if (atBottom) {
            scrollToTop();
        } else {
            scrollToBottom();
        }
    };

    if (showScrollButton) {
        return (
            <ScrollBtn
                onClick={handleScrollClick}
                $disabled={isAutoScrolling}
                aria-label='Scrolla till toppen/botten'
                title='Scrolla tilll till toppen/botten'
                $atBottom={atBottom}
            >
                <Arrow width='22px' height='100%' fill='#ffffff' />
            </ScrollBtn>
        )
    } 
}

export default ScrollButton